import { useLazyQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import FileUpload from '../../components/Popups/FileUpload';
import { DELETE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import './QuestionBank.scss';
import { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import ViewPage from '../../components/ViewPage/ViewPage';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import ToasterWithMessage from '../../components/toaster';
import { useAppSelector } from '../../redux/app/hooks';
import QuestionBankList from '../../components/QuestionBankList/QuestionBankList';
import { materialsData } from '../../utils/interface';
import { STUDENT_ROLE, TEACHER_ROLE, VIRTUAL_S3_PATH } from '../../utils/constants';
import { GET_ALL_QUESTIONS_BANK, UPLOAD_QUESTIONS_BANK } from './api/QuestionsBankQuery';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getScreenDimensions } from '../../utils/helper';

const QuestionBank = () => {
    const { CloudDownload, uploadCloud } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [qsBankUrl, setQsBankUrl] = useState<string>();
    const [qsBankFilename, setQsBankFilename] = useState<string>();
    const [qsBankCsvFileData, setQsBankCsvFileData] = useState<any>(); //Need to change
    const [qsBankFileData, setQsBankFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [qsBankOpen, setQsBankOpen] = useState<boolean>(false);
    const [qsBankOpenCsv, setQsBankOpenCsv] = useState(false); //Need to change
    const [questionBankData, setQuestionBankData] = useState<[materialsData]>();
    const [qsBankUploadProgress, setQsBankUploadProgress] = useState(0);
    const [materialAction,setMaterialAction] = useState<string>('');
    const [qsBankUploadFailed, setQsBankUploadFailed] = useState<boolean>(false);
    const [qsBankUploadFileName, setQsBankUploadFileName] = useState<string>('');
    const [qsBankUploaded, setQsBankUploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const [subCategory, setSubCategory] = useState<string>('Questions Bank');
    const backNavigation = role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const baseURL = process.env.REACT_APP_FRONTEND_URL;

    
    const [getAllQuestionBank, { loading }] = useLazyQuery(GET_ALL_QUESTIONS_BANK, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getAllQuestionBanks?.allquestionbanks) {
                setQuestionBankData(data?.getAllQuestionBanks?.allquestionbanks);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(questionBankData && questionBankData.length > 0){
        questionBankData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[profile?.getCurrentUser?.nodes, questionBankData, readFeed, role])

    const [uploadQuestionBank] = useMutation(UPLOAD_QUESTIONS_BANK, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.uploadQuestionBanks) {
                setQsBankFileData(null);
                if (qsBankFilename) {
                    setQsBankUploadFileName(qsBankFilename);
                }
                setQsBankUploaded(true);
                setQsBankUploadProgress(100);
                setQsBankFilename('');
                setQsBankUrl('');
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            if (qsBankFilename) {
                setQsBankUploadFileName(qsBankFilename);
            }
            error(err?.message);
            setQsBankUploaded(true);
            setQsBankUploadProgress(0);
            setQsBankUploadFailed(true);
        }
    });

    const [updateQuestionBank] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteQuestionBank] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllQuestionBank({
                    variables: {
                        input: {
                            sjId: selectedSubjectId,
                            cId: selectedClassRoomId,
                            limit: null,
                            offset: null,
                        }
                    }
                })
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    useEffect(() => {
        getAllQuestionBank({
            variables: {
                input: {
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    limit: null,
                    offset: null,
                }
            }
        });
    }, []);

    useEffect(() => {
        if (qsBankFileData && qsBankFilename && qsBankFilename !== '' && qsBankUrl) {
            uploadQuestionBank({
                variables: {
                    filename: qsBankFilename?.replace(/\.csv$/, "")?.trim(), //Need to change
                    filepath: qsBankUrl,
                    filesize: qsBankFileData?.size,
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId
                }
            });
        }
    }, [qsBankFileData, qsBankFilename, qsBankUrl]);

    //To open csv in detailed view
    const handleOpenFile = (pdfData: materialsData) => {
        setSubCategory(`Questions Bank / ${pdfData?.filename}`);
        const setState = { ...state, isQuestionBank: true, data: pdfData, backNavigation: { path: '/student-classroom/ebooks/materials/question-bank', state: state } }
        setQsBankCsvFileData(pdfData);
        if ( role === STUDENT_ROLE ) {
            if (pdfData?.status !== "COMPLETED") {
                navigate('/student-classroom/question-bank/test', { 
                    state: setState
                });
            }
            else {
                navigate('/student-classroom/question-bank/view', { 
                    state: setState
                });
            }
        }
        else if(role === TEACHER_ROLE){
            setQsBankOpenCsv(true);
        }
    }

    //To close csv detailed view
    const handleCloseCsv = () => {
        setQsBankOpenCsv(false);
        setQsBankCsvFileData(undefined);
    }

    //To done actions in materials
    const handleMaterialActions = (data: materialsData, action: string) => {
        if (action === "share") {
            setMaterialAction("share");
            updateQuestionBank({
                variables: {
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Questions bank",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "undoShare") {
            setMaterialAction("undoShare");
            updateQuestionBank({
                variables: {
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Questions bank",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        } else if (action === "delete") {
            setMaterialAction('');
            deleteQuestionBank({
                variables: {
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Questions bank"
                }
            })
        }
    }

    //To open upload popup
    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setQsBankOpen(true);
    };

    return (
        <div className="QuestionBank">
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={qsBankOpenCsv ? subCategory : 'Questions Bank'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={qsBankOpenCsv}
                onClose={handleCloseCsv}
                setOpen={setQsBankOpen}
                backNavigation={{ path: backNavigation, state: state }}
                demoFile={true}
            />
            {
                (qsBankOpenCsv) ?
                    <div className='QuestionBankView'>
                        <ViewPage data={qsBankCsvFileData} isQuestionBank={true}/>
                    </div>
                    :
                    <>
                        {
                            loading ? <Loader bottom='165px' />
                                :
                                <div className='QuestionBankBody'>
                                    <QuestionBankList
                                        isQuestionBank={true}
                                        questionBankData={questionBankData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                        setRefetch={null}
                                    />
                                </div>
                        }
                        {(role !== STUDENT_ROLE)&& <div className='sampleDemoFileMobileContainer'>
                            <a  href={baseUrl + VIRTUAL_S3_PATH + 'materials/QuestionsBankSample.csv'} download rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className='link'>
                                <img src={CloudDownload} alt="upload" className='downloadImage' />
                                <label className='demoFilename'>{`Sample csv`}</label>
                            </a>
                        </div>}
                        {role !== STUDENT_ROLE && <div className='libraryUploadButtonMobileQuestionBank' onClick={handleOpenUpload}>
                            <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>}
                    </>
            }
            {isUploadOpen && <FileUpload type='questionsBank' name="Questions bank" setUrl={setQsBankUrl} open={qsBankOpen} setOpen={setQsBankOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setQsBankFilename} setFileData={setQsBankFileData} setUploadFailed={setQsBankUploadFailed} setUploadProgress={setQsBankUploadProgress} setuploaded={setQsBankUploaded} setUploadFileName={setQsBankUploadFileName}/>}
            {qsBankUploaded && <UploadToaster uploaded={qsBankUploaded} setuploaded={setQsBankUploaded} uploadProgress={qsBankUploadProgress} setUploadProgress={setQsBankUploadProgress} fileName={qsBankUploadFileName} setUploadFileName={setQsBankUploadFileName} uploadFailed={qsBankUploadFailed} setUploadFailed={setQsBankUploadFailed} />}

            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !qsBankOpenCsv &&
                            <div className='libraryHeaderUploadContainer'> 
                             {(role !== STUDENT_ROLE  && getScreenDimensions().isMobileScreen)&& <div className='sampleContainer'>
                        <a  href={baseURL+'materials/QuestionsBankSample.csv'} download rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className='link'>
                            <img src={CloudDownload} alt="upload" className='downloadImage' />
                            <label className='demoFilename'>{`Sample csv`}</label>
                        </a>
                    </div>}
                                <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                               
                            </div>}
        </div>
    )
}

export default QuestionBank;